import { useSelector } from 'react-redux';

import * as deskingSelectors from '@makemydeal/dr-dash-store/selectors/deskingSelectors';

import { useAiVehicleRecommendationSlideout } from '../AiVehicleRecommendationSlideout/AiVehicleRecommendationProvider';

export const useVehicleRecommendationsLink = (scopeId: string) => {
    const { showRecommendations } = useAiVehicleRecommendationSlideout();
    const aiVehicleRecommendations = useSelector(deskingSelectors.getAiVehicleRecommendations);

    return () => showRecommendations(aiVehicleRecommendations, scopeId);
};
